import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="w-full max-w-7xl mx-auto px-4 md:px-6 py-3">
      <ol className="flex items-center gap-1.5 text-sm flex-wrap">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={index} className="flex items-center gap-1.5">
              {index > 0 && (
                <span className="text-foreground-400 select-none">/</span>
              )}
              {isLast || !item.to ? (
                <span className={isLast ? 'text-foreground-700 font-medium' : 'text-foreground-400'}>
                  {item.label}
                </span>
              ) : (
                <Link
                  to={item.to}
                  className="text-foreground-500 hover:text-primary-600 transition-colors no-underline"
                >
                  {item.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}